import { render, staticRenderFns } from "./EntryWeekSummary.vue?vue&type=template&id=2fa00e4e&scoped=true&"
import script from "./EntryWeekSummary.vue?vue&type=script&lang=js&"
export * from "./EntryWeekSummary.vue?vue&type=script&lang=js&"
import style0 from "./EntryWeekSummary.vue?vue&type=style&index=0&id=2fa00e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa00e4e",
  null
  
)

export default component.exports